export const removeEmptyVals = (obj) => {
    return Object.keys(obj)
      .filter(
        (key) => obj[key] !== null && obj[key] !== undefined && obj[key] !== ""
      )
      .reduce((acc, k) => {
        acc[k] = obj[k];
        return acc;
      }, {});
  };